var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuSubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4 2.0625V19.9375C26.4 20.4875 26.202 20.9688 25.806 21.3813C25.41 21.7938 24.948 22 24.42 22H1.98C1.452 22 0.99 21.7938 0.594 21.3813C0.198 20.9688 0 20.4875 0 19.9375V2.0625C0 1.5125 0.198 1.03125 0.594 0.61875C0.99 0.20625 1.452 0 1.98 0H24.42C24.948 0 25.41 0.20625 25.806 0.61875C26.202 1.03125 26.4 1.5125 26.4 2.0625ZM1.98 5.80938H24.42V2.0625H1.98V5.80938ZM1.98 10.2438V19.9375H24.42V10.2438H1.98Z",
    fill: "#3D3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSubscribe);
export default __webpack_public_path__ + "static/media/menu-subscribe.4d4c331714d30c068d9494803e7b9bc8.svg";
export { ForwardRef as ReactComponent };